module.exports = __webpack_public_path__ + "img/wifi.9bdf95d9.svg";